import React, { createContext, useContext } from "react";
import HttpClient from "./helpers/HttpClient";

type HttpClientContextType = {
  getClient: <T>(endpoint: string) => HttpClient<T>;
};

const HttpClientContext = createContext<HttpClientContextType | undefined>(undefined);

export const HttpClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // You can add global config here (e.g., base URL, auth headers)
  const getClient = <T,>(endpoint: string) => new HttpClient<T>(endpoint);

  return (
    <HttpClientContext.Provider value={{ getClient }}>
      {children}
    </HttpClientContext.Provider>
  );
};

export const useHttpClient = () => {
  const context = useContext(HttpClientContext);
  if (!context) throw new Error("useHttpClient must be used within a HttpClientProvider");
  return context.getClient;
};